export const lineMapping: Record<string, string> = {
  classic: 'Ligne Mobile',
  dataonly: 'SIM Data',
};
